import { DestroyRef, Injectable, inject, signal } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { ActivationEnd } from '@angular/router';

import { LayoutNavigationConfig } from '@frontend/sports/common/client-config-data-access';
import { RouteTag } from '@frontend/sports/common/core/data-access/route';
import { RouterEventsService } from '@frontend/sports/common/core/utils/router-events';

@Injectable({ providedIn: 'root' })
export class CleanNavigationComponentVisibilityService {
    private layoutNavConfig = inject(LayoutNavigationConfig);
    private routerEvents = inject(RouterEventsService);

    readonly subNavigationVisibility = signal<boolean>(true);
    readonly subNavigationVisibility$ = toObservable(this.subNavigationVisibility);

    constructor() {
        const destroyRef = inject(DestroyRef);

        if (!this.layoutNavConfig.useCleanNavigation) {
            return;
        }
        this.routerEvents.currentActivationEnd.pipe(takeUntilDestroyed(destroyRef)).subscribe((e) => this.routeChanged(e));
    }

    private routeChanged(event?: ActivationEnd): void {
        if (!event) {
            return;
        }

        this.subNavigationVisibility.set(CleanNavigationComponentVisibilityService.isSubNavigationVisible(event));
    }

    private static isSubNavigationVisible(event: ActivationEnd): boolean {
        if (event.snapshot.data?.tag !== RouteTag.Competition) return true;

        const { region, league } = event.snapshot.params;
        return !region && !league;
    }
}
